/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './DocumentsList.scss';
import BaseReactComponent from '../../Util/BaseReactComponent';
import baseComponent from '../../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import DocumentRow from './Row/DocumentRow';
import {changeDocumentPosition} from '../../../actioncreators/ZehnderActions.js';
import Modal from 'react-bootstrap/lib/Modal';

const SortableItem = SortableElement(({value, deleteDocument}) => <DocumentRow value={value} deleteDocument={deleteDocument}/>);

const SortableList = SortableContainer(({items, deleteDocument}) => {
    return (
        <ul className="document-list">
            {items.map((document, index) =>
                    <SortableItem key={`item-${index}`} index={index} value={document} deleteDocument={deleteDocument}/>
            )}
        </ul>
    );
});

@connect(state => ({
    documents: state.zehnder.documents
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class DocumentsList extends BaseReactComponent {


    constructor(props) {
        super(props);

        this.state = {};
        this.state.documents = props.documents || [];
        this.state.deleteMode = false;
        this.state.documentToDelete = {};
    }

    componentDidMount() {
        this.setState({
            documents: this.props.documents
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            documents: nextProps.documents
        });
    }

    startDeleteMode() {
        this.setState({
            deleteMode: true
        });
    }

    stopDeleteMode() {
        this.setState({
            deleteMode: false
        });
    }

    removeDocument() {
        this.stopDeleteMode();
        this.props.removeDocument(this.state.documentToDelete);
    }

    deleteDocument(document) {
        this.state.documentToDelete = document;
        this.startDeleteMode();
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        let firstDocument = this.state.documents[oldIndex];
        let secondDocument = this.state.documents[newIndex];

        this.setState({
            documents: arrayMove(this.state.documents, oldIndex, newIndex)
        });

        if (oldIndex !== newIndex) {
            changeDocumentPosition(firstDocument.id, secondDocument.id)(this.props.dispatch);
        }

    };

    render() {
        return (
            <div>
                <Modal title="Delete user" onHide={this.stopDeleteMode.bind(this)} show={this.state.deleteMode}>
                    <Modal.Header>
                        {this.getMessage('delete-title')}
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                          {this.getIntlMessage('homepage.installer-company-editor.you-are-about-to-delete')}<b>{this.state.documentToDelete.name}</b><br/>
                          {this.getIntlMessage('homepage.installer-company-editor.sure')}
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <a className="btn btn-link" onClick={this.stopDeleteMode.bind(this)}>{this.getMessage('cancel-button')}</a>
                        <a className="btn btn-primary" onClick={this.removeDocument.bind(this)}>{this.getMessage('delete-label')}</a>
                    </Modal.Footer>
                </Modal>

                <SortableList items={this.state.documents} onSortEnd={this.onSortEnd} useDragHandle={true} deleteDocument={this.deleteDocument.bind(this)}/>
            </div>
        )
    }

}

DocumentsList.propTypes = {
    removeDocument: React.PropTypes.func
};

DocumentsList.defaultProps = {
    componentName: 'documents-list'
};

export default DocumentsList;




// WEBPACK FOOTER //
// /src/components/Document/List/DocumentsList.js